import { render, staticRenderFns } from "./AddPersonPhoneNumberDialog.vue?vue&type=template&id=3b09e3b0&scoped=true&"
import script from "./AddPersonPhoneNumberDialog.vue?vue&type=script&lang=js&"
export * from "./AddPersonPhoneNumberDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b09e3b0",
  null
  
)

export default component.exports